import { useCallback, MouseEventHandler } from 'react';
import { Popover } from '../../common/components/Popover/Popover';
import {
  AdLabel,
  StyledIcon,
} from '../ResultView/ResultList/ProfileCards/search-card/SearchAdCard/SearchAdCard.styles';
import PrivacyIcon from './PrivacyIcon.svg';
import { Footer, StyledLink } from './PrivacyInfo.styles';

export const PrivacyInfo = ({ brandName }: { brandName?: string }) => {
  const handleLabelClick: MouseEventHandler = useCallback(ev => {
    ev.preventDefault();
  }, []);

  return (
    <Popover
      content={
        <>
          <p>
            {brandName} is a paid advertising partner of Healthengine. The advertisement appearing
            on this page has been provided by {brandName} for the benefit of Healthengine users.
          </p>
          <p>
            By clicking on this advertisement, you will be directed to an external website hosted by{' '}
            {brandName}.
          </p>
          <Footer>
            <PrivacyIcon />
            <StyledLink
              href="https://privacy.healthengine.com.au/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more about how Healthengine approaches privacy.
            </StyledLink>
          </Footer>
        </>
      }
    >
      <AdLabel onClick={handleLabelClick}>
        Ad
        <StyledIcon />
      </AdLabel>
    </Popover>
  );
};
